<template>
    <modal :show="show" class="white-content" @update:show="$emit('update:show', $event)">
      <h4 class="card-title">{{ $t('tools.returnMultiTool') }} - {{ multiToolReturningName }}</h4>
      <div>
        <el-table :data="multiToolReturnTable" class="clickable-rows" @row-click="toggleRow">
          <el-table-column :label="$t('common.info')" min-width="150">
            <template #default="{ row }">
              <div>
                <div><strong>{{ $t('toolGroups.quantity') }}:</strong> {{ row.quantity }}</div>
                <div><strong>{{ $t('tools.reservation') }}:</strong> {{ row.reservationDate }}</div>
                <div><strong>{{ $t('common.project') }}:</strong> {{ row.project }}</div>
                <div><strong>{{ $t('common.type') }}:</strong> {{ row.type }}</div>
                <div v-if="allowAllUsersToReturn"><strong>{{ $t('tools.reservedBy') }}:</strong> {{ row.user }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="50">
            <template #default="{ row }">
              <el-checkbox
                :model-value="!!selectedMultiToolsToReturnRows[row.id]"
                @click.stop
                @change="$emit('selection-change', { row, checked: $event })"
              ></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="row">
        <div class="col-sm d-flex justify-content-end">
          <material-button type="standard" color="success" fill @click="$emit('confirm')">{{ $t('common.confirm') }}</material-button>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import { ElTable, ElTableColumn, ElCheckbox } from 'element-plus';
  import Modal from './Modal.vue';
  import MaterialButton from '../MaterialButton.vue';

  export default {
    components: { Modal, MaterialButton, ElTable, ElTableColumn, ElCheckbox },
    props: {
      show: { type: Boolean, required: true },
      multiToolReturnTable: { type: Array, required: true },
      multiToolReturningName: { type: String, required: true },
      allowAllUsersToReturn: { type: Boolean, default: false },
      selectedMultiToolsToReturnRows: { type: Object, required: true }
    },
    emits: ['update:show', 'selection-change', 'confirm'],
    methods: {
      toggleRow(row) {
        this.$emit('selection-change', { row, checked: !this.selectedMultiToolsToReturnRows[row.id] });
      }
    }
  };
  </script>

  <style scoped>
  .clickable-rows :deep(.el-table__row) {
    cursor: pointer;
  }
  </style>